module.exports = __webpack_public_path__ + "img/symbol_4.a26732c3.png";